import React from 'react';
import { Box, Typography } from '@mui/material';
import ClaimFormInfoDialog from './ClaimFormInfoDialog';

type Props = {
  open: boolean;
  claimNumber: string;
  onOk: () => void;
};

const Step1CompleteOverlayDialog: React.FC<Props> = ({ open, claimNumber, onOk }) => (
  <ClaimFormInfoDialog
    open={open}
    onOk={onOk}
    title="Your claim has been saved"
    titleId="step1-complete-dialog-title"
  >
    <Typography variant="body2" component="p" sx={{ fontWeight: 700, mb: 1.5 }}>
      Your claim ID is: {claimNumber || '—'}
    </Typography>
    <Typography variant="body2" component="p" sx={{ mb: 1.5 }}>
      We sent you an email just now.
    </Typography>
    <Typography variant="body2" component="p" sx={{ mb: 1.5 }}>
      The information you entered has been saved.
    </Typography>
    <Typography variant="body2" component="p" sx={{ mb: 2 }}>
      You can resume submitting your claim at any time using the &apos;Complete Your Claim&apos; button in your
      email.
    </Typography>
    <Box component="section" sx={{ mt: 0.5 }}>
      <Typography variant="body2" component="p" sx={{ mb: 1.5 }}>
        To process your claim, we require complete details of all damaged or stolen items.
      </Typography>
      <Typography variant="body2" component="p" sx={{ mb: 1.5 }}>
        In the next step, please list each item individually.
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        Claims cannot be processed unless all damaged or stolen items are itemized 1 by 1.
      </Typography>
    </Box>
  </ClaimFormInfoDialog>
);

export default Step1CompleteOverlayDialog;
